import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { Button } from "@babackapp/ui/components/button";
import useTranslation from "@babackapp/translations/use-translation";

interface ResendSuccessProps {
  onBackToSignIn: () => void;
}

export function ResendSuccess({ onBackToSignIn }: ResendSuccessProps) {
  const t = useTranslation();

  return (
    <div className="text-center">
      <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
        <CheckCircleIcon className="h-8 w-8 text-green-600" aria-hidden="true" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        Verification email sent
      </h3>
      <p className="text-sm text-gray-600 mb-6">
        We've sent a new verification link to your email.
      </p>
      <Button onClick={onBackToSignIn} className="w-full">
        {t("verifyEmail.success.signIn")}
      </Button>
    </div>
  );
}